// extracted by mini-css-extract-plugin
export default {"img":"styles_img__mxomM","imgContainer":"styles_imgContainer__OJzAf","download":"styles_download__0KKPY","icon":"styles_icon__BDBHA"};